import { gql } from '@apollo/client';

const UPDATE_USER_MUTATION = gql`
  mutation updateUser($userData: UpdateUserInput!) {
    updateUser(userData: $userData) {
      isSuccess
      message
      user {
        id
        isEmailVerified
        roles
        title
        firstName
        lastName
        username
        email
        contact {
          address
          city
          state
          country
          zip
          phone1
          phone2
          nightPhone
          fax
        }
      }
    }
  }
`;

export default UPDATE_USER_MUTATION;
